import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { FormControl, FormControlLabel, Grid, Stack, Tab, Tabs, TextField, Box, Typography, Switch, FormGroup, Button } from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Select from 'react-select';
import FormPageHeader from "../utilities/FormPageHeader";
import { emailValidation, checkString, checkBlankSpace, checkSpecialChar } from "../utilities/FormValidation";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import TimezoneSelect, { allTimezones } from "react-timezone-select";
import { countryToAlpha2 } from 'country-to-iso';
import * as Flags from 'country-flag-icons/react/3x2'
import jwtDecode from "jwt-decode";
import customStyles from "app/shared-components/SelectCustomStyle";
import {
    buildSelectedShowrooms,
    getSelectedShowroomIds,
    getSelectedShowroomNames,
    hasSameShowroomIds,
} from "../utilities/showroomUtils";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { userContext } from "app/theme-layouts/layout1/Layout1";
import RequiredLabel from "../utilities/RequiredLabel";

const Profile = () => {
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [middleName, setMiddleName] = useState();
    const [userDetail , setUserDetail] = useContext(userContext)
    const [userName, setUserName] = useState();
    const [userId, setUserId] = useState();
    const [selectedShowrooms, setSelectedShowrooms] = useState([]);
    const [email, setEmail] = useState();
    const [profileImage, setProfileImage] = useState();
    const [profileImageUrl, setProfileImageUrl] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const [role, setRole] = useState([]);
    const [gender, setGender] = useState();
    // const [password, setPassword] = useState();
    const [birthDate, setBirthDate] = useState();
    const [designation, setDesignation] = useState();
    const [timezone, setTimeZone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const [country, setCountry] = useState();
    const [partner, setPartner] = useState();
    const [imgFile, setImgFile] = useState();
    const [partnerId, setPartnerId] = useState();
    const [active, setActive] = useState(false);
    const [checkStatus, setCheckStatus] = useState(true);
    const [editData, setEditData] = useState();

    const formRef = useRef(null);
    const params = useParams();
    const navigate = useNavigate();
    const userList = JSON.parse(localStorage.getItem('userList'));
    const [tabValue, setTabValue] = useState(0);
    const [error, setError] = useState();
    const [countryOptions, setCountryOptions] = useState();
    const [roleOptions, setRoleOptions] = useState();
    const [showroomOptions, setShowroomOptions] = useState();
    const [companyOptions, setCompanyOptions] = useState();
    const [validError, setValidError] = useState({});
    const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
    const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.user}`;
    const [checksubmit, setCheckSubmit] = useState(false);
    const queryParam = new URLSearchParams(window.location.search);
    const fileInputRef = useRef(null);

    const token =
      localStorage &&
      localStorage.getItem("token") &&
      jwtDecode(localStorage.getItem("token"));

    const hasMdAdminRole = ["ROLE_ADMIN", "ROLE_MD"].some((role) =>
      token?.scope?.includes(role)
    );

    const handleSubmit = async () => {
        let model = {
            firstName: firstName,
            middleName: middleName,
            lastName: lastName,
            userName: userName,
            birthDate: birthDate,
            timeZone: timezone?.value || '',
            email: email,
            phoneNumber: phoneNumber,
            roles: role,
            companyName: partner,
            companyId: partnerId,
            showroomName: getSelectedShowroomNames(selectedShowrooms),
            showroomId: getSelectedShowroomIds(selectedShowrooms),
            active: active,
            country: country,
            profileImage: profileImage,
            // password: password,
            designation
        };

        try {
          if (!hasMdAdminRole) {
            if (imgFile) {
              const formData = new FormData();
              formData.append("image", imgFile);
              await OAuthService.uploadFile(userUrl + '/image/upload', formData)
            }
            await OAuthService.updateData(url, userId, model);
            setUserDetail(model)
            navigate('/users');
          } else {
            if (firstName && lastName && userName && email && role && country && !validError.firstName
                && !validError.middleName && !validError.lastName && !validError.userName && !validError.email &&
                !validError.role && !validError.country) {
                if (imgFile) {
                    const formData = new FormData();
                    formData.append("image", imgFile);
                    await OAuthService.uploadFile(userUrl + '/image/upload', formData)
                }
                await OAuthService.updateData(url, userId, model);
                setUserDetail(model)
                navigate('/users');
            }
          }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }

    }
    const editUser = async (email) => {
        try {
            const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${email}`;
            const result = await OAuthService.getList(url);
            const user = result?.data;

            if (user.country) {
                let code = countryToAlpha2(user.country)
                const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/companiesByCntyCode?countryCode=${code}&size=1000`;
                const companies = await OAuthService.getList(url);
                const result = companies?.data?.result?.map((value) => {
                    return { label: value.text, value: value.text, id: value.id }
                })

                setCompanyOptions(result);
            }

            let loadedShowroomOptions = [];
            if (user.companyId) {
                const apiurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${user.companyId}&size=1000`;
                const showrooms = await OAuthService.getList(apiurl);
                const showroomresult = showrooms?.data?.result?.map((value) => {
                    return { label: value.text, value: value.text, id: value.id }
                })
                loadedShowroomOptions = showroomresult || [];
                setShowroomOptions(showroomresult);
            }
            console.log('user', user)
            user.timeZone && setTimeZone(user.timeZone);
            // const url1 = process.env.REACT_APP_API_KEY_URL
            // const url2 = user?._links.user.href.split("/api")[1]
            // setUserId(`${url1}api${url2}`)
            setUserId(user?._links.user.href.split('/').pop())
            setFirstName(user.firstName);
            setLastName(user.lastName);
            setMiddleName(user.middleName);
            setUserName(user.userName);
            setEmail(user.email);
            setPhoneNumber(user.phoneNumber);
            setRole(user.roles);
            setGender(user.gender);
            setBirthDate(user.birthDate);
            setActive(user.active);
            setPartner(user.companyName);
            setCountry(user.country);
            setProfileImage(user.profileImage);
            // setPassword(user.password)
            setSelectedShowrooms(buildSelectedShowrooms(user.showroomId, loadedShowroomOptions, user.showroomName));
            if (user.profileImage) {
                const response = await OAuthService.getDownload(userUrl + `/image/download/${user.profileImage}`);
                const imgURL = URL.createObjectURL(response.data)
                setProfileImageUrl(imgURL)
            }

      setEditData(user);
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    const handlePartnerChange = async (data) => {
        setPartner(data.value);
        setPartnerId(data.id);
        setSelectedShowrooms([]);
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${data.id}&size=100`;
        const showrooms = await OAuthService.getList(url);
        const result = showrooms?.data?.result?.map((value) => {
            return { label: value.text, value: value.text, id: value.id }
        })

        setShowroomOptions(result)
    }
    const handleShowroomChange = (data) => {
        if (!data || data.length === 0) return;
        setSelectedShowrooms(data);
    }
    const handleActiveChange = (e) => {
        setActive(e.target.checked);
    };
    useEffect(() => {
        if (localStorage.getItem('token')) {
            const token = jwtDecode(localStorage.getItem('token'));
            editUser(token.email);
        }
    }, [])
    useEffect(() => {
        const country = async () => {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}?size=1000`;
            const countries = await OAuthService.getList(url);

            const result = countries?.data?._embedded.countries.map((value) => {
                const Flag = Flags[value.isoCode];
                return { label: value.name, value: value.name, code: value.isoCode, icon: value.isoCode && <Flag width={18} style={{ marginInline: "5px" }} /> }
            })
            setCountryOptions(result);
        }
        const role = async () => {
            const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.role}?size=1000`;
            const roles = await OAuthService.getList(url);
            const result = roles?.data?._embedded.roles.map((value) => {
                return { label: value?._links?.role.href.split("/").pop(), value: value?._links?.role.href.split("/").pop() }
            })

            setRoleOptions(result);
        }
        country();
        role();
    }, [])
    /**
   * Tab Change
   */
    const handleTabChange = (event, value) => {
        setTabValue(value);
    }
    const handleRoleChange = (value) => {
        const roles = value.map((row) => {
            return row.value
        });
        setRole(roles);
    }
    const checkUniqueEmail = async (email) => {
        const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${email}`;
        const result = await OAuthService.getList(url);
        if (result.data) {
            const usersId = result?.data?._links?.user?.href?.split("/").pop();
            if (usersId !== userId) {
                setValidError({ ...validError, email: "This email is already exist" });
            }
        }
    }
    const checkUniqueUserName = async (name) => {
        const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByUserNameIgnoreCase?userName=${name}`;
        const result = await OAuthService.getList(url);
        const usersId = result?.data?._links?.user?.href?.split("/").pop();
        if (usersId !== userId) {
            setValidError({
                ...validError,
                userName: "This username is already exist",
            });
        }
    }

    const handleCountryChange = async (data) => {
        setCountry(data.value);
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/companiesByCntyCode?countryCode=${data.code}&size=1000`;
        const companies = await OAuthService.getList(url);
        const result = companies?.data?.result.map((value) => {
            return { label: value.text, value: value.text, id: value.id }
        })

        setCompanyOptions(result);
    };

    const handleTimeZone = (e) => {
        setTimeZone(e)
    }

    const handleChangeUploadProfile = (e) => {
        const file = e.target.files[0];
        setImgFile(file)
        const imgURL = URL.createObjectURL(file)
        setProfileImageUrl(imgURL)
        setProfileImage(file.name)
    }

    const removeDocument = () => {
        setProfileImageUrl('')
        setProfileImage(null)
        setImgFile('')
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }

    useEffect(() => {
      if (!hasMdAdminRole) {
        if (editData) {
          if (
            typeof birthDate !== typeof editData.birthDate ||
            profileImage !== editData.profileImage
          ) {
            setCheckStatus(false);
          } else {
            setCheckStatus(true);
          }
        } else {
          setCheckStatus(false);
        }
      } else {
        if (
          firstName &&
          lastName &&
          userName &&
          role.length > 0 &&
          email &&
          country &&
          partner
        ) {
          if (editData) {
            if (
              firstName !== editData.firstName ||
              lastName !== editData.lastName ||
              middleName !== editData.middleName ||
              userName !== editData.userName ||
              JSON.stringify(role) !== JSON.stringify(editData.roles) ||
              email !== editData.email ||
              country !== editData.country ||
              partner !== editData.companyName ||
              typeof birthDate !== typeof editData.birthDate ||
              active !== editData.active ||
              !hasSameShowroomIds(selectedShowrooms, editData.showroomId) ||
              timezone !== editData.timeZone ||
              profileImage !== editData.profileImage
            ) {
              setCheckStatus(false);
            } else {
              setCheckStatus(true);
            }
          } else {
            setCheckStatus(false);
          }
        } else {
          setCheckStatus(true);
        }
      }
    }, [
      firstName,
      lastName,
      userName,
      middleName,
      role,
      email,
      country,
      partner,
      birthDate,
      active,
      selectedShowrooms,
      timezone,
      profileImage,
    ]);

    return (
        <div className="w-full overflow-scroll">
            <FormPageHeader
                componentName="User"
                // handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                currentPage={"Profile"}
                saveDisable={checkStatus}
                error={error}
            >
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor="secondary"
                    textColor="inherit"
                    sx={{ color: 'yellow' }}
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{ root: 'w-full border-b-1' }}
                >
                    <Tab label="General" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
                </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24">
                <FormControl
                    ref={formRef}
                    className="flex flex-col justify-center"
                >
                    <div className={tabValue !== 0 ? 'hidden' : ''}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Box spacing={2} className="mb-20 mt-20" sx={{ p: 2, border: '1px dashed grey' }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Stack>
                                                <RequiredLabel>First Name</RequiredLabel>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    error={(checksubmit && !firstName) || validError.firstName ? true : false}
                                                    name="firstName"
                                                    value={firstName}
                                                    onChange={(e) => { setFirstName(e.target.value.toUpperCase()); setValidError({ ...validError, firstName: checkString(e.target.value) || checkSpecialChar(e.target.value) }) }}
                                                    helperText={(checksubmit && !firstName) ? "This field is required" : validError.firstName}
                                                    disabled={!hasMdAdminRole}
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: firstName ? true : false,
                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Stack>
                                                <label>Middle Name</label>
                                                <TextField
                                                    className="mb-16"
                                                    error={(checksubmit && !middleName) || validError.middleName ? true : false}
                                                    type="text"
                                                    name="middleName"
                                                    value={middleName}
                                                    onChange={(e) => { setMiddleName(e.target.value.toUpperCase()); setValidError({ ...validError, middleName: checkString(e.target.value) || checkSpecialChar(e.target.value) }) }}
                                                    disabled={!hasMdAdminRole}
                                                    variant="outlined"
                                                    helperText={(checksubmit && !middleName) ? "This field is required" : validError.middleName}
                                                    InputLabelProps={{
                                                        shrink: middleName ? true : false,
                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Stack>
                                                <RequiredLabel>Last Name</RequiredLabel>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="lastName"
                                                    error={(checksubmit && !lastName) || validError.lastName ? true : false}
                                                    value={lastName}
                                                    onChange={(e) => { setLastName(e.target.value.toUpperCase()); setValidError({ ...validError, lastName: checkString(e.target.value) || checkSpecialChar(e.target.value) }) }}
                                                    disabled={!hasMdAdminRole}
                                                    variant="outlined"
                                                    helperText={(checksubmit && !lastName) ? "This field is required" : validError.lastName}
                                                    InputLabelProps={{
                                                        shrink: lastName ? true : false,
                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>


                                    <Stack>
                                        <RequiredLabel>User Name</RequiredLabel>
                                        <TextField
                                            className="mb-16"
                                            type="text"
                                            name="userName"
                                            error={(checksubmit && !userName) || validError.userName ? true : false}
                                            value={userName}
                                            onChange={(e) => { setUserName(e.target.value); setValidError({ ...validError, userName: checkBlankSpace(e.target.value) || checkSpecialChar(e.target.value) }) }}
                                            disabled={!hasMdAdminRole}
                                            variant="outlined"
                                            onBlur={(e) => checkUniqueUserName(e.target.value)}
                                            helperText={(checksubmit && !userName) ? "This field is required" : validError.userName}
                                            InputLabelProps={{
                                                shrink: userName ? true : false,
                                            }}
                                        />
                                    </Stack>

                                    <Stack className="mb-16">
                                        <RequiredLabel>Select role</RequiredLabel>
                                        <Select name="role"
                                            value={roleOptions && roleOptions.filter(obj => role.includes(obj.value))}
                                            isMulti
                                            className="select"
                                            isDisabled={!hasMdAdminRole}
                                            onChange={handleRoleChange}
                                            options={roleOptions}
                                            styles={customStyles(((checksubmit && role.length === 0) || validError.role) && "#f44336")}
                                        />
                                        <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && role.length === 0) ? "This field is required" : validError.role}</Typography>
                                    </Stack>
                                    {/* <Stack>
                                        <TextField
                                            className="mb-16"
                                            type="text"
                                            name="designation"
                                            label="Designation"
                                            value={designation}
                                            onChange={(e) => { setDesignation(e.target.value); setValidError({ ...validError, designation: checkString(e.target.value) }) }}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: designation ? true : false,
                                            }}
                                        />
                                    </Stack> */}
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box spacing={2} className="mb-20 mt-20" sx={{ p: 2, border: '1px dashed grey' }}>
                                    <Stack>
                                        <RequiredLabel>Email</RequiredLabel>
                                        <TextField
                                            className="mb-16"
                                            type="text"
                                            name="email"
                                            value={email}
                                            disabled={!hasMdAdminRole}
                                            error={(checksubmit && !email) || validError.email ? true : false}
                                            onChange={(e) => { setEmail(e.target.value); setValidError({ ...validError, email: emailValidation(e.target.value) }) }}
                                            onBlur={(e) => checkUniqueEmail(e.target.value)}
                                            helperText={(checksubmit && !email) ? "This field is required" : validError.email}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: email ? true : false,
                                            }}
                                        />
                                    </Stack>

                                    <Stack>
                                        <label>Birthdate</label>
                                        <TextField
                                            className="mb-16"
                                            type="date"
                                            value={birthDate}
                                            name="birthDate"
                                            onChange={(e) => setBirthDate(e.target.value)}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            sx={{ svg: 'red', input: 'red' }}
                                        />
                                    </Stack>
                                </Box>
                            </Grid>
                        </Grid>



                        <Box className="mb-20 mt-20" sx={{ p: 2, border: '1px dashed grey' }}>

                            <Stack className="mb-16">
                                <RequiredLabel>Select Country</RequiredLabel>
                                <Select name="country"
                                    value={(country && countryOptions) && countryOptions.filter(obj => country.includes(obj.value))}
                                    onChange={handleCountryChange}
                                    isDisabled={(queryParam.get('showroomId') || queryParam.get('customerId') || !hasMdAdminRole) ? true : false}
                                    options={countryOptions}
                                    styles={customStyles(((checksubmit && !country) || validError.country) && "#f44336")}
                                    className="select"
                                    getOptionLabel={e => (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {e.icon}
                                            <span style={{ marginLeft: 5 }}>{e.label}</span>
                                        </div>
                                    )}
                                />
                                <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !country) ? "This field is required" : validError.country}</Typography>
                            </Stack>

                            <Stack className="mb-16">
                                <RequiredLabel>Select Partner</RequiredLabel>
                                <Select name="partner"
                                    isDisabled={(queryParam.get('showroomId') || queryParam.get('customerId') || !hasMdAdminRole) ? true : false}
                                    value={(partner && companyOptions) && companyOptions.filter(obj => partner.includes(obj.value))}
                                    onChange={handlePartnerChange}
                                    styles={customStyles()}
                                    options={companyOptions}
                                    className="select"
                                />
                            </Stack>
                            <Stack className="mb-16">
                                <label>Select Showroom</label>
                                <Select name="showroom"
                                    isMulti
                                    isDisabled={(queryParam.get('showroomId') || !hasMdAdminRole) ? true : false}
                                    value={selectedShowrooms}
                                    getOptionValue={(option) => String(option.id)}
                                    onChange={handleShowroomChange}
                                    styles={customStyles()}
                                    options={showroomOptions}
                                    className="select"
                                />
                            </Stack>
                            <Stack>
                                <div style={{ color: '#000' }}>
                                    <label>Select Timezone</label>
                                    <TimezoneSelect
                                        value={timezone}
                                        onChange={handleTimeZone}
                                        className="mb-16"
                                        styles={customStyles()}
                                        isDisabled = {!hasMdAdminRole}
                                        timezones={{ ...allTimezones }}
                                    />
                                </div>
                            </Stack>
                            <FormGroup>
                                <FormControlLabel control={<Switch checked={active} onChange={handleActiveChange} disabled={!hasMdAdminRole} />} label="Active" />
                            </FormGroup>
                                <Grid display={"flex"}>
                                    {profileImageUrl && (<><img
                                        className="w-[50px] h-[50px]"
                                        src={profileImageUrl}
                                        alt={"profile picture"}
                                    />
                                    <Grid className="self-center">
                                        <FuseSvgIcon className=' w-32 h-32 cursor-pointer' onClick={() => removeDocument()}>heroicons-outline:x</FuseSvgIcon>
                                    </Grid></>)}
                                    <Button
                                        // onClick={handleSubmit}
                                        className='h-fit self-center'
                                        variant="contained"
                                        component="label"
                                        color="secondary"
                                        size="small"
                                    >
                                        <input hidden accept="image/*" type="file" ref={fileInputRef}
                                            onChange={(e) => handleChangeUploadProfile(e)}
                                        />
                                        <Typography color="black" >Upload Profile</Typography>
                                    </Button>
                                </Grid>
                        </Box>
                    </div>
                </FormControl>
            </div>

        </div >
    )
}

export default Profile;
